import type { ReactNode } from 'react'
import styles from './StaticFallback.module.css'

/**
 * A readable, static fallback shown when an interaction's configuration is
 * invalid (or JavaScript interaction is otherwise unavailable). It preserves the
 * learner-facing content as plain text so nothing is lost. Reused by every
 * interaction component.
 */
export function StaticFallback({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className={styles.fallback} role="note">
      <p className={styles.title}>{title}</p>
      {children ? <div className={styles.body}>{children}</div> : null}
    </div>
  )
}
